import { SET_USER_SESSION, CLEAR_USER_SESSION } from "./types";

export const setUserSession = (userSession) => (dispatch) => {
  dispatch({
    type: SET_USER_SESSION,
    payload: userSession,
  });
};

export const clearUserSession = () => (dispatch) => {
  dispatch({
    type: CLEAR_USER_SESSION,
  });
};
